import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'DialogueOptionText',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
// Native v-model defers commits until compositionend for Chinese input methods.
const text = computed({ get: () => props.modelValue, set: (value: string) => emit("update:modelValue", value) });

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
    "aria-label": "选项文本",
    placeholder: "填写选项…"
  }, null, 512)), [
    [_vModelText, text.value]
  ])
}
}

})